import { ListFilter } from '../components/List';
import { typesIds } from './types';

export const filtersIds = {
  all: 'all',
  responses: 'responses',
  favourites: 'favourites',
  requested: 'requested',
  downloads: 'downloads',
  uploads: 'uploads',
};

export const filters: Array<ListFilter> = [
  {
    id: filtersIds.all,
    label: 'All',
    param: '',
  },
  {
    id: filtersIds.responses,
    label: 'Responses',
    param: 'response',
  },
  {
    id: filtersIds.favourites,
    label: 'favourites',
    param: 'is_favourite',
  },
  {
    id: filtersIds.requested,
    label: 'requested',
    param: 'is_requested',
  },
  {
    id: filtersIds.downloads,
    label: 'downloads',
    filterQuery: { 'type.category': { $in: [typesIds.downloads] } },
  },
  {
    id: filtersIds.uploads,
    label: 'uploads',
    filterQuery: { 'type.category': { $in: [typesIds.uploads] } },
  },
];
